import { Module } from './moduleTypes';

export interface User {
  id?: string;
  firstname: string;
  lastname: string;
  email: string;
  modules?: Module[];
  roles?: string[] | undefined | null;
  permissions?: string[];
  companies?: string[];
  status?: UserStatus;
  createdAt?: Date;
  updatedAt?: Date;
  lastLogin?: Date;
  profilesJson?: string;
  tenantId?: string;
  tenantType?: string;
  companyList?: string[];
  userCompanies?: any[];
}

export interface UpdateUserDto {
  id?: string;
  firstname: string;
  lastname: string;
  tenantId: string;
  status: UserStatus;
  profilesJson?: string;
  roles: string[];
  companyIds: string[];
}

export interface UserDto extends UpdateUserDto {
  userName: string;
  email: string;
}

export interface UserSettings {
  defaultPage?: string;
}

export enum UserStatus {
  Active = 'Active',
  Block = 'Block',
  Pending = 'Pending',
}
